import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';
import Leaf from '../../../../Assets/StorefrontIcons/Leaf.svg';

function FeaturesOne() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`FEATURES_ONE${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl outline-none select-none">
            <div className="w-full h-[100px] flex gap-2 rounded-md bg-[#EAEAEA] p-2">
                <div className="flex gap-2 w-full">
                    <div className="size-4">
                        <img src={Leaf} alt="" />
                    </div>

                    <div className="w-[calc(100%-16px)] h-full flex flex-col gap-1">
                        <h1 className='text-[#121212] font-semibold text-[12px] leading-[14px] text-left'>Eco-friendly</h1>

                        <p className='text-[#666666] font-medium text-[8px] leading-4 text-left'>Lorem ipsum dolor sit amet consectetur. Semper morbi id euismod commodo at ut cursus duis. Enim blandit lectus nibh nisl pellentesque sem tincidunt nibh egestas. Sed.</p>
                    </div>
                </div>
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>Features 1</p>
        </button>
    );
}

export default FeaturesOne;
